import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccordionComponent {
    @Input() title: string;
    @Input() isOpen: boolean;
    @Input() disabled = false;

    @Output() toggleStatus = new EventEmitter<boolean>();

    public openItem() {
        this.toggleStatus.emit();
    }
}
